// Email Management Actions
export const FETCH_EMAIL_MANAGEMENT_REQUEST = 'FETCH_EMAIL_MANAGEMENT_REQUEST';
export const FETCH_EMAIL_MANAGEMENT_SUCCESS = 'FETCH_EMAIL_MANAGEMENT_SUCCESS';
export const FETCH_EMAIL_MANAGEMENT_FAILURE = 'FETCH_EMAIL_MANAGEMENT_FAILURE';

export const FETCH_EMAIL_MANAGEMENT_BY_ID_REQUEST = 'FETCH_EMAIL_MANAGEMENT_BY_ID_REQUEST';
export const FETCH_EMAIL_MANAGEMENT_BY_ID_SUCCESS = 'FETCH_EMAIL_MANAGEMENT_BY_ID_SUCCESS';
export const FETCH_EMAIL_MANAGEMENT_BY_ID_FAILURE = 'FETCH_EMAIL_MANAGEMENT_BY_ID_FAILURE';

export const CREATE_EMAIL_MANAGEMENT_REQUEST = 'CREATE_EMAIL_MANAGEMENT_REQUEST';
export const CREATE_EMAIL_MANAGEMENT_SUCCESS = 'CREATE_EMAIL_MANAGEMENT_SUCCESS';
export const CREATE_EMAIL_MANAGEMENT_FAILURE = 'CREATE_EMAIL_MANAGEMENT_FAILURE';
export const RESET_CREATE_EMAIL_MANAGEMENT = 'RESET_CREATE_EMAIL_MANAGEMENT';

export const UPDATE_EMAIL_MANAGEMENT_REQUEST = 'UPDATE_EMAIL_MANAGEMENT_REQUEST';
export const UPDATE_EMAIL_MANAGEMENT_SUCCESS = 'UPDATE_EMAIL_MANAGEMENT_SUCCESS';
export const UPDATE_EMAIL_MANAGEMENT_FAILURE = 'UPDATE_EMAIL_MANAGEMENT_FAILURE';

export const DELETE_EMAIL_MANAGEMENT_REQUEST = 'DELETE_EMAIL_MANAGEMENT_REQUEST';
export const DELETE_EMAIL_MANAGEMENT_SUCCESS = 'DELETE_EMAIL_MANAGEMENT_SUCCESS';
export const DELETE_EMAIL_MANAGEMENT_FAILURE = 'DELETE_EMAIL_MANAGEMENT_FAILURE';

export const fetchEmailManagementRequest = (params = {}) => ({
    type: FETCH_EMAIL_MANAGEMENT_REQUEST,
    payload: params,
});

export const fetchEmailManagementSuccess = (data) => ({
    type: FETCH_EMAIL_MANAGEMENT_SUCCESS,
    payload: data,
});

export const fetchEmailManagementFailure = (error) => ({
    type: FETCH_EMAIL_MANAGEMENT_FAILURE,
    payload: error,
});

export const fetchEmailManagementByIdRequest = (emailManagementId) => ({
    type: FETCH_EMAIL_MANAGEMENT_BY_ID_REQUEST,
    payload: emailManagementId,
});

export const fetchEmailManagementByIdSuccess = (data) => ({
    type: FETCH_EMAIL_MANAGEMENT_BY_ID_SUCCESS,
    payload: data,
});

export const fetchEmailManagementByIdFailure = (error) => ({
    type: FETCH_EMAIL_MANAGEMENT_BY_ID_FAILURE,
    payload: error,
});

export const createEmailManagementRequest = (partnerId, emailManagementData) => ({
    type: CREATE_EMAIL_MANAGEMENT_REQUEST,
    payload: { partnerId, emailManagementData },
});

export const createEmailManagementSuccess = (data) => ({
    type: CREATE_EMAIL_MANAGEMENT_SUCCESS,
    payload: data,
});

export const createEmailManagementFailure = (error) => ({
    type: CREATE_EMAIL_MANAGEMENT_FAILURE,
    payload: error,
});

export const resetCreateEmailManagement = () => ({
    type: RESET_CREATE_EMAIL_MANAGEMENT,
});

export const updateEmailManagementRequest = (emailManagementId, emailManagementData) => ({
    type: UPDATE_EMAIL_MANAGEMENT_REQUEST,
    payload: { emailManagementId, emailManagementData },
});

export const updateEmailManagementSuccess = (data) => ({
    type: UPDATE_EMAIL_MANAGEMENT_SUCCESS,
    payload: data,
});

export const updateEmailManagementFailure = (error) => ({
    type: UPDATE_EMAIL_MANAGEMENT_FAILURE,
    payload: error,
});

export const deleteEmailManagementRequest = (emailManagementId) => ({
    type: DELETE_EMAIL_MANAGEMENT_REQUEST,
    payload: emailManagementId,
});

export const deleteEmailManagementSuccess = () => ({
    type: DELETE_EMAIL_MANAGEMENT_SUCCESS,
});

export const deleteEmailManagementFailure = (error) => ({
    type: DELETE_EMAIL_MANAGEMENT_FAILURE,
    payload: error,
});

